import Color from 'color';
import { ColorParam } from '../type/color';

export const applyVibrancy = (startingColor: ColorParam, paletteVibrancy: number): Color => {
  // Clamp the paletteVibrancy value to be between 0 and 1.
  paletteVibrancy = Math.max(0, Math.min(1, paletteVibrancy));

  // paletteVibrancy is a 0 - 1 value. paletteDarkness is a 1 - 0 value which is inverted from vibrancy.
  const paletteDarkness = 1 - paletteVibrancy;

  // Arbitrary value that gave good results by eye.
  const BlackenMultiplier = 4;

  const color = Color(startingColor);

  // Low saturation colors will blacken less.
  const colorSaturationFactor = color.saturationl() * 0.01;
  // Low value colors (already dark) will blacken less.
  const colorValueFactor = color.value() * 0.01;
  // The less similar the saturation and value are the
  const closenessFactor = 1 - Math.abs(colorSaturationFactor - colorValueFactor);
  // Low chroma colors (pastels and whites) will blacken less.
  const colorChromaFactor = color.chroma() * 0.01;

  // Multiplied together we get a value by which we will blacken the color.
  const blackenFactor =
    paletteDarkness *
    BlackenMultiplier *
    colorSaturationFactor *
    colorValueFactor *
    closenessFactor *
    colorChromaFactor;
  const colorBlackened = color.blacken(blackenFactor);

  // Use an exponential curve to reduce the saturation more and more the lower the value of paletteVibrancy.
  const saturationFactor = 1 - Math.pow(paletteDarkness, 2);
  const colorDeSaturated = colorBlackened.saturationl(colorBlackened.saturationl() * saturationFactor);

  return colorDeSaturated;
};

export const vibrancyFactory = (paletteVibrancy: number) => {
  return (startingColor: ColorParam) => {
    return applyVibrancy(startingColor, paletteVibrancy);
  };
};
